'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

var _uiImage = require('@spp/ui-image');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-static-element-interactions */
var AutoplayOverlay = function (_Component) {
    (0, _inherits3.default)(AutoplayOverlay, _Component);

    function AutoplayOverlay(props) {
        (0, _classCallCheck3.default)(this, AutoplayOverlay);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AutoplayOverlay.__proto__ || (0, _getPrototypeOf2.default)(AutoplayOverlay)).call(this, props));

        _this.playVideo = _this.playVideo.bind(_this);
        _this.closeOverlay = _this.closeOverlay.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(AutoplayOverlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.timer = setTimeout(this.playVideo, this.props.countdownTime * 1000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timer);
        }
    }, {
        key: 'playVideo',
        value: function playVideo() {
            clearTimeout(this.timer);
            this.props.playVideo();
        }
    }, {
        key: 'closeOverlay',
        value: function closeOverlay() {
            clearTimeout(this.timer);
            this.props.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                label = _props.label,
                countdownTime = _props.countdownTime,
                imageAsset = _props.imageAsset,
                bgImageAsset = _props.bgImageAsset,
                theme = _props.theme;


            return _react2.default.createElement(
                'div',
                { className: theme.overlayRoot },
                _react2.default.createElement(_uiImage.ImageAsset, {
                    theme: theme.overlayBackgroundImage,
                    urls: bgImageAsset.urls,
                    sizes: '250px'
                }),
                _react2.default.createElement(
                    'div',
                    { className: theme.overlayContainer },
                    _react2.default.createElement(
                        'div',
                        { className: theme.overlayImageContainer, onClick: this.playVideo },
                        _react2.default.createElement(
                            'div',
                            { className: theme.overlayImageRatio },
                            _react2.default.createElement(_uiImage.ImageAsset, {
                                theme: theme.overlayImage,
                                urls: imageAsset.urls,
                                sizes: '250px'
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: theme.overlayCountdown },
                                _react2.default.createElement(
                                    'svg',
                                    {
                                        version: '1.1',
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        width: '40px', height: '40px',
                                        viewBox: '0 0 100 100'
                                    },
                                    _react2.default.createElement('path', {
                                        className: theme.overlayCountdownPath,
                                        style: { animationDuration: countdownTime + 's' },
                                        strokeWidth: '8',
                                        d: 'M 50, 8 a 42,42 0 0,1 0,84 a 42,42 0 0,1 0,-84'
                                    })
                                ),
                                _react2.default.createElement('div', { className: theme.overlayPlayButton })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.overlayTextContainer },
                        _react2.default.createElement(
                            'span',
                            { className: theme.overlayLabel },
                            label
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: theme.overlayTitle },
                            title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.overlayCloseButton, onClick: this.closeOverlay },
                        _react2.default.createElement(
                            'span',
                            { className: theme.overlayCloseButtonSymbol },
                            '\u2715'
                        )
                    )
                )
            );
        }
    }]);
    return AutoplayOverlay;
}(_react.Component);

AutoplayOverlay.propTypes = {
    title: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string,
    countdownTime: _propTypes2.default.number,
    imageAsset: _irisPropTypes.objects.imageAsset.isRequired,
    bgImageAsset: _irisPropTypes.objects.imageAsset.isRequired,
    playVideo: _propTypes2.default.func.isRequired,
    cancel: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        overlayRoot: _propTypes2.default.string,
        overlayBackgroundImage: _propTypes2.default.string,
        overlayContainer: _propTypes2.default.string,
        overlayImageContainer: _propTypes2.default.string,
        overlayImageRatio: _propTypes2.default.string,
        overlayImage: _propTypes2.default.string,
        overlayCountdown: _propTypes2.default.string,
        overlayCountdownPath: _propTypes2.default.string,
        overlayPlayButton: _propTypes2.default.string,
        overlayTextContainer: _propTypes2.default.string,
        overlayLabel: _propTypes2.default.string,
        overlayTitle: _propTypes2.default.string,
        overlayCloseButton: _propTypes2.default.string,
        overlayCloseButtonSymbol: _propTypes2.default.string
    }).isRequired
};
AutoplayOverlay.defaultProps = {
    label: 'Playing next',
    countdownTime: 6
};
exports.default = AutoplayOverlay;
//# sourceMappingURL=AutoplayOverlay.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/components/AutoplayOverlay.js
 ** module id = 706
 ** module chunks = 1
 **/